const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '全天候追踪更新',
    desc: '编辑团队 7×24 小时不间断追踪全网黑料热点，确保你不错过任何一个值得关注的吃瓜事件。从爆料出现到事件发酵，从多方回应到真相浮出——黑料入口始终站在吃瓜第一线。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度后真相调查',
    desc: '我们不止步于表面爆料，而是深入追踪每一起黑料事件的来龙去脉。通过多方信息交叉验证和时间线梳理，还原黑料故事的全貌，让你了解事件背后的真实脉络。',
  },
  {
    icon: 'ri-stack-fill',
    title: '结构化黑料故事库',
    desc: '黑料入口将碎片化的吃瓜信息整合为结构化的专题内容，按事件、人物、时间线进行系统归类。无论你是新读者还是老瓜友，都能快速找到感兴趣的黑料内容并了解完整背景。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          为什么选择黑料入口作为你的吃瓜第一站
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, i) => (
            <div
              key={i}
              className="text-center p-6 md:p-8 bg-background-50 border border-background-200/60 rounded-lg"
            >
              <div className="w-14 h-14 mx-auto rounded-full bg-primary-500/15 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-200 mb-3 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}